import { Fragment } from "react/jsx-runtime";
import IFrameWrapper from "../IframeWrapper";
import AppWrapper from "../AppWrapper";
import ChatContainer from "../ChatContainer";
import PopupWrapper from "../PopupWrapper";
import IncomingCallPopupWrapper from "../IncomingCallPopupWrapper";
import ChatWidget from "../ChatWidget";
import { useEffect, useRef, useState } from "react";
import { Message } from "../../types/message";

const WidgetChildrenWrapper = ({ config }: any) => {
  let chatWindowRef = useRef<any>();
  let popupWindowRef = useRef<any>();
  let launcherRef = useRef<any>();
  let callWindowRef = useRef<any>();

  const [open, setOpen] = useState(false);
  const [currentConversation, setCurrentConversation] = useState<string | null>(
    config?.mx_cid
  );
  const [incomingCall, setIncomingCall] = useState(null);
  const [typingIndicator, setTypingIndicator] = useState<Message | null>(null);
  const [messages, setMessages] = useState<Message[]>([]);

  useEffect(() => {
    if (open && incomingCall) {
      if (chatWindowRef?.current) {
        chatWindowRef?.current?.classList?.add("incoming_call");
      }
    }
    console.log(chatWindowRef);
  }, [open, incomingCall, chatWindowRef]);

  useEffect(() => {
    const handleMessage = (event: any) => {
      console.log(event.data);
      try {
        if (event.data && event.data.type === "MAXIMISE_CHAT_WIDGET_OPEN") {
          if (popupWindowRef?.current) {
            setTypingIndicator(null);
            setMessages([]);
          }
          if (chatWindowRef?.current) {
            chatWindowRef?.current?.classList?.add("open");
            setOpen(true);
            setIncomingCall(null);
          }
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_CLOSE"
        ) {
          if (chatWindowRef?.current) {
            chatWindowRef?.current?.classList?.remove("open");
            setOpen(false);
          }
          if (event.data?.messages?.length > 0) {
            setMessages(event.data?.messages || []);
          }
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_ALERT"
        ) {
          console.log(event.data);
          if (popupWindowRef?.current) {
            popupWindowRef?.current?.classList?.add("open");
          }
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_ALERT_CLOSE"
        ) {
          setMessages([]);
          setTypingIndicator(null);
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_CALL_CONNECTED"
        ) {
          if (chatWindowRef?.current) {
            chatWindowRef?.current?.classList?.remove("incoming_call");
            chatWindowRef?.current?.classList?.add("expand");
          }
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_CALL_DISCONNECTED"
        ) {
          if (chatWindowRef?.current) {
            chatWindowRef?.current?.classList?.remove("incoming_call");
            chatWindowRef?.current?.classList?.remove("expand");
          }
          setIncomingCall(null);
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_CHAT_WIDGET_CALL_INCOMING"
        ) {
          if (chatWindowRef?.current && open) {
            chatWindowRef?.current?.classList?.add("incoming_call");
          }

          if (!open) {
            setIncomingCall(event.data);
          }
        } else if (event.data && event.data.type === "MAXIMISE_TYPING_ALERT") {
          if (!open) {
            setTypingIndicator(event.data.typingIndicator || null);
            console.log("MAXIMISE_TYPING_ALERT", event.data);
          }
        } else if (
          event.data &&
          event.data.type === "MAXIMISE_MESSAGES_ALERT"
        ) {
          if (!open) {
            setMessages(event.data?.messages || []);
            console.log("MAXIMISE_MESSAGES_ALERT", event.data);
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [open]);

  const handleChatWindowReady = (container: any) => {
    chatWindowRef.current = container?.current;
    console.log("chatWindowRef", chatWindowRef);
  };

  const handleLauncherReady = (container: any) => {
    launcherRef.current = container?.current;
  };

  const handlePopupWindowReady = (container: any) => {
    popupWindowRef.current = container?.current;
  };

  const handleCallWindowReady = (container: any) => {
    callWindowRef.current = container?.current;
  };

  return (
    <Fragment>
      <IFrameWrapper
        onContainerReady={handleChatWindowReady}
        className="pulse_frame"
      >
        <AppWrapper config={{ ...config, mx_cid: currentConversation }}>
          <ChatContainer />
        </AppWrapper>
      </IFrameWrapper>
      {(typingIndicator || messages.length > 0) && !open && (
        <IFrameWrapper
          onContainerReady={handlePopupWindowReady}
          className="pulse_alert"
        >
          <PopupWrapper typingIndicator={typingIndicator} messages={messages} />
        </IFrameWrapper>
      )}
      {incomingCall && !open && (
        <IFrameWrapper
          onContainerReady={handleCallWindowReady}
          className="pulse_alert"
        >
          <IncomingCallPopupWrapper callMeta={incomingCall} />
        </IFrameWrapper>
      )}
      <IFrameWrapper
        onContainerReady={handleLauncherReady}
        className={"pulse_launcher"}
      >
        <ChatWidget open={open} />
      </IFrameWrapper>
    </Fragment>
  );
};

export default WidgetChildrenWrapper;
